module.exports = __webpack_public_path__ + "static-v-shop/1765458264834/img/logo_naranja.00996b70.png";